import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const PrescriptionPage = lazy(() => import("./PrescriptionHistoryPage.tsx"));

const MedicationHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <PrescriptionPage />
    </Suspense>
  );
};

export default MedicationHistoryPageLazy;
